<template>

      <v-card class="fullHeight pa-40">
<div style="text-align:center">
<button
  @click="btnRojo"
  style="height: 120px;
padding:5px;
    background: red;
    width: 120px;
    border: solid;
    border-radius: 60px;">
  BOTON DE PRUEBA, NO TOCAR
</button>



<div>
  <textarea v-model="textArea" rows="10"></textarea>
</div>
</div>
      </v-card>

 </template>
<script>

export default {
  data() {
    return {

    };
  },
  created() {
    this.$store.dispatch('set', {key: 'title', val:'Pruebas'});

  },
  computed: {

  },
  components: {
  },
  methods: {

    btnRojo() {

    },

  },
};
</script>
